import {IStoreState} from "../types";

export const isDomainValid = (state: IStoreState) =>
    state.domainCheck.isDomainValid;
